import { render, staticRenderFns } from "./MonthlyRanking.vue?vue&type=template&id=5cf2acda&scoped=true"
import script from "./MonthlyRanking.vue?vue&type=script&lang=js"
export * from "./MonthlyRanking.vue?vue&type=script&lang=js"
import style0 from "./MonthlyRanking.vue?vue&type=style&index=0&id=5cf2acda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf2acda",
  null
  
)

export default component.exports